import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login_service/login.service';
import { ModelService } from 'src/app/services/model.service';

declare let ga: (p1: any, p2?: any, p3?: any, p4?: any) => {};

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	public loading: boolean = false;
	public username: string;
	public password: string;
	public rememberMe: boolean;
	public extraInfoString: string;


	@ViewChild('fieldUsername', { static: false }) private fieldUsername: any;
	@ViewChild('fieldPassword', { static: false }) private fieldPassword: any;
	@ViewChild('fieldRememberMe', { static: false }) private fieldRememberMe: any;

	@ViewChild('SVGColoresRivisa') SVGColoresRivisa: ElementRef;

	constructor(
		private router: Router,
		public loginService: LoginService,
		public modelService: ModelService
	) { }


	public ngOnInit() {
		this.rememberMe = this.modelService.getUser().shouldRemember;

		this.loginService.connectivityError = false;
	}

	// ############################################################ login()
	// Botón loginarse.
	public login(): void {
		this.loginService.connectivityError = false;
		let errorRes = {};
		if (Math.min(this.password.length, this.username.length) !== 0) {
			this.loading = true;
			this.loginService.login(this.username, this.password)
				.subscribe(
					(succed: any) => {
						this.loading = false;
						if (succed.ok) {
							// Adquirir el proyecto guardado en cache.
							// _NEW const pd: ProjectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
							// Tener en cuenta si hay proyecto.
							// Si el proyecto está vacío.
							// _NEW if (!pd) {
							//	localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(new ProjectData()));
							//this.router.navigate([' /hold']); // Ir al hold
							//	this.router.navigate([' /satelite']);
							//}
							// Si el proyecto está vacío.
							//else if (!pd.userId) {
							//this.router.navigate([' /hold']); // Ir al hold
							//	this.router.navigate([' /satelite']);
							//}
							// Si tiene rol de admin no controlar si el proyecto es suyo.
							// En caso de tener proyecto y no ser el propietario del mismo, crear proyecto vacío.
							//else if (succed.rol === 0 && (pd.userId !== succed.id)) {
							//	localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(new ProjectData()));

							// TODO Limpiar el localstorage
							this.router.navigate(['/hold']); // Ir al hold

							//	this.router.navigate([' /satelite']);
							//}
							//else {
							// Ir al editor correspondiente.
							//	if (pd.renderer === Utils.SATELITE) {
							//		this.router.navigate([' /satelite']);
							//	}
							//	else {
							//		this.router.navigate([' /scheme']);
							//this.router.navigateByUrl(' /', { skipLocationChange: true }).then(() => {
							//	this.router.navigate([' /scheme'],{ queryParams: { state: 'loginOk' } });
							//});
							//	}
							//}
						}
						else {

							this.router.navigate(['/login']);
						}
					},
					(error: Error) => {
						this.loading = false;
						this.loginService.connectivityError = true;
						this.extraInfoString = error.message;
						console.log(error);
					});
		} else {
			if (this.username.length === 0) this.fieldUsername.nativeElement.focus();
			if (this.password.length === 0) this.fieldPassword.nativeElement.focus();
		}
	}

	// ############################################################ shouldRemember(bool)
	// Recordar últma sesión.
	public shouldRemember(value: boolean): void {
		this.modelService.getUser().shouldRemember = value;
	}

}
